<template>
    <el-carousel height="500px" indicator-position="outside">
        <el-carousel-item v-for="item in imageList" :key="item">
            <img :src="item.imageUrl" alt="images" class="img_item" @click="toOpen(item)">
        </el-carousel-item>
    </el-carousel>
</template>

<script>
import {Resource} from '@/services/resource'

export default {
    data() {
        return {
            imageList: []
        };
    },
    beforeMount() {
        this.getImages()
    },
    methods: {
        getImages() {
            Resource.getBanner.post({}, {
                timeString: '2021-02-01',
                // 1丞乐 2娄铎
                platform: 1
            }).then(res => {
                if (res.code === "SUCCESS") {
                    this.imageList = res.data
                }
                console.log(res)
            })
        },
        toOpen(item) {
            if (item.jumpLink) {
                window.open(item.jumpLink)
            }
        }
    }
};
</script>
<style lang="less" scoped>
.img_item {
  width: 100%;
  height: 500px;
}
</style>
